module.exports = __webpack_public_path__ + "img/teacher-days-bg-img.32d9faf9.png";